function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:currentColor;stroke:currentColor;stroke-width:.5px}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "explore",
  transform: "translate(-510 -285)"
}, /*#__PURE__*/React.createElement("g", {
  id: "explorenetwork",
  transform: "translate(516 291)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_120",
  d: "M398.03-564.7h-2.455a1.072 1.072 0 00-1.074 1.074v2.456a1.072 1.072 0 001.074 1.074h2.455a1.072 1.072 0 001.074-1.074v-2.456a1.072 1.072 0 00-1.074-1.074zm.5 3.491a.467.467 0 01-.46.46h-2.455a.466.466 0 01-.46-.46v-2.455a.467.467 0 01.46-.46h2.455a.467.467 0 01.46.46z",
  className: "cls-2",
  transform: "translate(-394.5 564.699)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  d: "M417.03-564.7h-2.455a1.072 1.072 0 00-1.074 1.074v2.456a1.072 1.072 0 001.074 1.074h2.455a1.072 1.072 0 001.074-1.074v-2.456a1.1 1.1 0 00-1.074-1.074zm.46 3.491a.467.467 0 01-.46.46h-2.455a.467.467 0 01-.46-.46v-2.455a.467.467 0 01.46-.46h2.455a.467.467 0 01.46.46z",
  className: "cls-2",
  transform: "translate(-406.21 564.699)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_122",
  d: "M398.03-547.1h-2.455a1.072 1.072 0 00-1.074 1.074v2.455a1.072 1.072 0 001.074 1.074h2.455a1.072 1.072 0 001.074-1.074v-2.455a1.072 1.072 0 00-1.074-1.074zm.5 3.491a.467.467 0 01-.46.46h-2.455a.466.466 0 01-.46-.46v-2.455a.467.467 0 01.46-.46h2.455a.467.467 0 01.46.46z",
  className: "cls-2",
  transform: "translate(-394.5 554.461)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  d: "M417.03-547.1h-2.455a1.072 1.072 0 00-1.074 1.074v2.455a1.072 1.072 0 001.074 1.074h2.455a1.072 1.072 0 001.074-1.074v-2.455a1.1 1.1 0 00-1.074-1.074zm.46 3.491a.467.467 0 01-.46.46h-2.455a.467.467 0 01-.46-.46v-2.455a.467.467 0 01.46-.46h2.455a.467.467 0 01.46.46z",
  className: "cls-2",
  transform: "translate(-406.21 554.461)"
})));

var SvgExplore = function SvgExplore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExplore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/explore.dc60e5a9.svg";
export { ForwardRef as ReactComponent };